module.exports = __webpack_public_path__ + "static/img/nav_bg.b204845b.png";